import { FC } from "react";
import { Store, storeLogos } from "@types";
import styles from "./RatingSource.module.css";

interface RatingSourceProps {
  store: Store;
  productLink?: string;
}

export const RatingSource: FC<RatingSourceProps> = ({ store, productLink }) => {
  return (
    <a
      href={productLink ? productLink : "#"}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.ratingSource}
      title={`View on ${store}`}
    >
      <img
        src={storeLogos[store]}
        alt={`${store} logo`}
        className={styles.storeLogo}
      />
    </a>
  );
};
